import React, { useContext } from "react";
import { Menu, Dropdown, Image } from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import { Link, NavLink } from "react-router-dom";
import { RootStoreContext } from "../../app/stores/rootStore";

const NavBarDaily: React.FC = () => {
  const rootStore = useContext(RootStoreContext);
  const { user, logout } = rootStore.userStore;
  return (
    <Menu fixed="top" inverted>
      {user && (
        <Menu.Item>
          <Image avatar spaced="left" src={user.image || "/assets/user.png"} />
          <Dropdown pointing="top left" text={user.displayName}>
            <Dropdown.Menu>
              <Dropdown.Item
                as={Link}
                to={`/employeeportal/profile`}
                text="My profile"
                icon="user"
              />
              <Dropdown.Item
                as={Link}
                to={`/employeeportal/certificate`}
                text="My certificate"
                icon="certificate"
              />
              <Dropdown.Item
                as={Link}
                to={"/employeeportal/assets"}
                text="My assets"
                icon="laptop"
              />
              <Dropdown.Item
                as={Link}
                to={"/employeeportal/timesheet"}
                text="My time sheet"
                icon="calendar times"
              />
              <Dropdown.Item onClick={logout} text="Logout" icon="power" />
            </Dropdown.Menu>
          </Dropdown>
        </Menu.Item>
      )}
      {user && (
        <Dropdown item text="Mobile">
          <Dropdown.Menu>
            <Dropdown.Item
              as={NavLink}
              to="/employeeportal/techniciantransmission"
              text="Transmission"
            />
            <Dropdown.Item
              as={NavLink}
              to="/employeeportal/sitevodafone"
              text="Site"
            />
          </Dropdown.Menu>
        </Dropdown>
      )}
      {user && (
        <Dropdown item text="BDOD">
          <Dropdown.Menu>
            <Dropdown.Item
              as={NavLink}
              to="/employeeportal/technicianproject"
              text="Project"
            />
            <Dropdown.Item
              as={NavLink}
              to="/employeeportal/bdodjobs"
              text="Job List"
            />
          </Dropdown.Menu>
        </Dropdown>
      )}
      {user && (
        <Dropdown item text="JOB LOG">
          <Dropdown.Menu>
            <Dropdown.Item
              as={NavLink}
              to="/employeeportal/fttbhour"
              text="FTTB"
            />
            <Dropdown.Item
              as={NavLink}
              to="/employeeportal/fttchour"
              text="FTTC"
            />
            <Dropdown.Item
              as={NavLink}
              to="/employeeportal/unifyjob"
              text="Unify"
            />
          </Dropdown.Menu>
        </Dropdown>
      )}
      
      {user && (user.role === "Admin" || user.role === "Super") && (
        <Menu.Item header as={NavLink} exact to="/home" position="right">
          <img
            src="/assets/brighten.png"
            alt="logo"
            style={{ marginRight: 10 }}
          />
          HOME
        </Menu.Item>
      )}
    </Menu>
  );
};

export default observer(NavBarDaily);
